import { ShelfTalkerCard } from '../shelf-talker-card';
import { PaperSize } from '../../../../shared/paper-size';
import { Orientation } from '../../../../enum/dto/orientation.enum';

export abstract class PostCardShelfTalker extends ShelfTalkerCard {
  getCardHeightInInches(): number {
    return 4;
  }

  getCardWidthInInches(): number {
    return 6;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 2;
  }

  nColumns(): number {
    return 1;
  }

  nRows(): number {
    return 2;
  }

  cardOrientationOnPortraitPage(): Orientation {
    return Orientation.Landscape;
  }
}
